import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import StyledCard from 'components/styled-card';
import { NightlyResponse } from 'types/hcp/pdfreport.type';
import { displayDateTime } from 'utils/helpers';

const RecordingInfo = ({ nightly }: { nightly: NightlyResponse }) => {
  const { t } = useTranslation();
  return (
    <StyledCard id="nightly-info" title={t('nightly.info', { night: nightly.night })}>
      <div>
        <Row gutter={[16, 16]}>
          <Col span={12}>{t('nightly.rec-start')}</Col>
          <Col span={12}>{displayDateTime(nightly?.variables?.RecordingStartTime)}</Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>{t('nightly.rec-end')}</Col>
          <Col span={12}>{displayDateTime(nightly?.variables?.RecordingEndTime)}</Col>
        </Row>
        {nightly?.settings?.showRecordingDuration && (
          <Row gutter={[16, 16]}>
            <Col span={12}>{t('nightly.rec-dur')}</Col>
            <Col span={12}>{nightly?.variables?.recordingDuration}</Col>
          </Row>
        )}
        <Row gutter={[16, 16]}>
          <Col span={12}>{t('nightly.rec-rej')}</Col>
          <Col span={12}>{nightly?.variables?.rejection}%</Col>
        </Row>
      </div>
    </StyledCard>
  );
};

export default RecordingInfo;
